export const AUTH_SMOOTH_DELAY = 700;